/**
 * OPUS-913 — the signed-in user's chosen avatar, persisted per user in
 * localStorage (key opus-avatar-<userId>). Shared so the footer, presence
 * cluster (heartbeat), and anywhere the current user's avatar is shown stay in
 * sync with the Edit-profile picker. avatar = { type:'initials'|'preset', color, icon }.
 */
const DEFAULT_AVATAR = { type: "initials", color: "#FF455C" };

export function getAvatarPref(userId) {
  if (!userId) return { ...DEFAULT_AVATAR };
  try {
    const v = JSON.parse(localStorage.getItem(`opus-avatar-${userId}`));
    if (v && v.type) return v;
  } catch (_) { /* ignore */ }
  return { ...DEFAULT_AVATAR };
}

export function setAvatarPref(userId, avatar) {
  if (!userId || !avatar) return;
  try { localStorage.setItem(`opus-avatar-${userId}`, JSON.stringify(avatar)); } catch (_) { /* ignore */ }
}
